import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowsUpDown,
  faHorizontalRule,
  faImage,
  faParagraph,
  faRectangle,
  faShareNodes,
} from "@fortawesome/pro-regular-svg-icons";
import type { BlockType } from "../../../domain/types";

export const BLOCK_PALETTE_ICONS: Record<
  Exclude<BlockType, "eyebrow" | "buttonRow">,
  IconDefinition
> = {
  text: faParagraph,
  image: faImage,
  button: faRectangle,
  divider: faHorizontalRule,
  spacer: faArrowsUpDown,
  social: faShareNodes,
};
